module.exports = __webpack_public_path__ + "media/bootstrap-icons/gear-wide-cc4d3993.svg";